import { Box, Flex } from '@blockanalitica/ui';

function NotFound() {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      gap="xs"
      height={['90vh', '90vh', '50vh']}>
      <Box borderRight="3px solid primary" fontSize="4" paddingRight="xs">
        404
      </Box>
      <div>Not Found</div>
    </Flex>
  );
}

export default NotFound;
